import { render, staticRenderFns } from "./DetailCodeItems.vue?vue&type=template&id=8d50e6f6&scoped=true"
import script from "./DetailCodeItems.vue?vue&type=script&lang=js"
export * from "./DetailCodeItems.vue?vue&type=script&lang=js"
import style0 from "./DetailCodeItems.vue?vue&type=style&index=0&id=8d50e6f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d50e6f6",
  null
  
)

export default component.exports